import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * PassesApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/passesApi/passesApi.service.js.
 *
 * Pass templates CRUD on /v2/api/pass/templates.
 */
const PASSES_TEMPLATES_BASE_V2 = "/v2/api/pass/templates";

interface PassTemplatePayload {
  id?: number | string;
  name: string;
  characters: unknown;
  series: unknown;
  attributes: unknown;
  state: unknown;
}

@Injectable({ providedIn: "root" })
export class PassesApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(PASSES_TEMPLATES_BASE_V2, {
        params: buildParams(props, PAGINATION_SEARCH_FIELDS),
      }),
    );
  }

  detail(props: { id: number | string }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(`${PASSES_TEMPLATES_BASE_V2}/${props.id}`),
    );
  }

  create(props: PassTemplatePayload): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.post<unknown>(PASSES_TEMPLATES_BASE_V2, {
        name: props.name,
        characters: props.characters,
        series: props.series,
        attributes: props.attributes,
        state: props.state,
      }),
    );
  }

  update(props: PassTemplatePayload): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(`${PASSES_TEMPLATES_BASE_V2}/${props.id}`, {
        id: props.id,
        name: props.name,
        characters: props.characters,
        series: props.series,
        attributes: props.attributes,
        state: props.state,
      }),
    );
  }

  remove(props: { id: number | string }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.delete<unknown>(`${PASSES_TEMPLATES_BASE_V2}/${props.id}`),
    );
  }
}
